export const p30_base = [
  ['2019/2020款 P40 V40 P80 地形模块', '电子件'],
  ['XP 2020离心喷头', '电子件'],
  ['XP 2020/2020 ST款 飞控主机', '电子件'],
  ['P20/P30/XP 2019/2020/2020 ST款 电调驱动板', '电子件'],
  ['XP 2020/2020 ST款 RTK模块', '电子件'],
  ['P20/P30 19/20款 P40 V40 P80 UPS模块', '电子件'],
  ['XP 2020 蠕动泵', '电子件'],
  ['XP 2020/2020 ST款 FOC电调', '电子件'],
  ['P20/P30 2019/2020款 XP 2020款 航灯', '电子件'],
  ['P80 XP双频天线-R', '电子件'],
  ['P30 2019/2020款 A16电机-长线', '电子件'],
  ['P80 XP 双频天线-L', '电子件'],
  ['P30 2019/2020款 A16电机-短线', '电子件'],
  ['P20/P30 2019/2020 款 模具版喷头', '电子件'],
  ['P20/P30 2019/2020款 中心仓转接板', '电子件'],
  ['P20/P30 2019/2020款 水泵控制板', '电子件'],
  ['XP 2020/2020 ST款 LED尾灯（含连线）', '电子件'],
  ['XP 2020/2020 ST款 药箱感应模块', '电子件'],
  ['P20/P30 2019蠕动泵', '电子件'],
  ['P20/P30 2019/2020款 版HDLS', '电子件'],
  ['P20/P30/XP 2019/2020/2020 ST款 地形模块成品', '电子件'],
  ['P20/P30 2019 XP 2020/2020 ST款 FOC电调', '电子件'],
  ['P20/P30 2019 P30 2020 款 三星七频GPS天线-L', '电子件'],
  ['P20/P30 2019 P20/P30 2020 款 三星七频GPS天线-R', '电子件'],
  ['P30 2020/2019款 航灯喷头-密封舱转接板连接长线', '电子件'],
  ['P30 2020/2019款 航灯喷头-密封舱转接板连接短线', '电子件'],
  ['P20/P30 2019/2020/XP 飞控', '电子件'],
  ['P30智能药箱传感器模块半成品（16L）', '电子件'],
  ['P20/P30 2019款 通用机身后向雷达半成品', '电子件'],
  ['P20/P30/XP 2017/2018/2019/2020款 水泵控制板-水泵连接线', '电子件'],
  ['P30 2019/2020 右4G天线', '电子件'],
  ['P30 2019/2020 左4G天线', '电子件'],
  ['P20/P30 2019 P30/P20/P10 2018 探照灯', '电子件'],
  ['P20/P30 2019 P20/P30 2020 款 双频天线-R', '电子件'],
  ['P20/P30 2019 P20/P30 2020 款 双频天线-L', '电子件'],
  ['P30 2020/2019款 飞控-喷洒系统连接线_1_01', '电子件'],
  ['P30 2019款 飞控-动力板连接线_1_01', '电子件'],
  ['P10/P20/P30/XP 18/19/20款 水泵驱动板-探照灯连接线', '电子件'],
  ['P20/P30 2019 款 P系列尾灯', '电子件'],
  ['P20/P30/XP 2019/2020 ST款 18P014 RTK', '电子件'],
  ['P30/P10/P20 18/19款 探照灯转接板', '电子件'],
  ['P20/P30/XP 2019/2020款 数据线', '电子件'],
]
export const p30_advance: string[][] = []
